(function () {
  "use strict";

  document.documentElement.setAttribute("data-insmia-navigation-script", "loaded");

  var runtimeVersion = 8;
  var runtimeProbeEvent = "insmia:navigation-runtime-" + runtimeVersion + ":probe";
  var runtimeInitializeEvent = "insmia:navigation:initialize";
  var runtimeProbe = new Event(runtimeProbeEvent, { cancelable: true });

  window.dispatchEvent(runtimeProbe);
  if (runtimeProbe.defaultPrevented) {
    window.dispatchEvent(new Event(runtimeInitializeEvent));
    return;
  }

  function directMatches(container, selector) {
    return Array.prototype.filter.call(container.querySelectorAll(selector), function (element) {
      return element.closest("[data-insmia-switcher]") === container;
    });
  }

  function activateDesktopSwitcher(switcher, key, focusTarget) {
    if (!switcher || !key) return;

    directMatches(switcher, "[data-insmia-switch]").forEach(function (control) {
      var active = control.getAttribute("data-insmia-switch") === key;
      control.classList.toggle("is-active", active);
      control.setAttribute("aria-expanded", active ? "true" : "false");
    });

    directMatches(switcher, "[data-insmia-panel]").forEach(function (panel) {
      var active = panel.getAttribute("data-insmia-panel") === key;
      panel.classList.toggle("is-active", active);
      panel.hidden = !active;
    });

    if (focusTarget instanceof HTMLElement) focusTarget.focus();
  }

  function initializeDesktopSwitcher(switcher) {
    if (!(switcher instanceof HTMLElement) || switcher.dataset.insmiaSwitcherReady === "true") return;

    var controls = directMatches(switcher, "[data-insmia-switch]");
    if (!controls.length) return;
    switcher.dataset.insmiaSwitcherReady = "true";

    var selected =
      controls.find(function (control) {
        return control.classList.contains("is-active");
      }) || controls[0];

    activateDesktopSwitcher(switcher, selected.getAttribute("data-insmia-switch"), false);
  }

  function mobileTabs(nav) {
    return Array.prototype.slice.call(nav.querySelectorAll("[data-insmia-mobile-tab]"));
  }

  function setMobilePanel(nav, key, focusTarget) {
    if (!nav || !key) return;

    mobileTabs(nav).forEach(function (tab) {
      var active = tab.getAttribute("data-insmia-mobile-tab") === key;
      tab.classList.toggle("is-active", active);
      tab.setAttribute("aria-pressed", active ? "true" : "false");
      tab.setAttribute("tabindex", "0");
    });

    nav.querySelectorAll("[data-insmia-mobile-panel]").forEach(function (panel) {
      var active = panel.getAttribute("data-insmia-mobile-panel") === key;
      panel.classList.toggle("is-active", active);
      panel.hidden = !active;
    });

    var panelScroller = nav.querySelector("[data-insmia-mobile-panels]");
    if (panelScroller) panelScroller.scrollTop = 0;
    if (focusTarget instanceof HTMLElement) focusTarget.focus();
  }

  function setMobileDisclosure(group, open) {
    if (!group) return;
    var disclosure = group.querySelector("[data-insmia-mobile-disclosure]");
    var children = group.querySelector("[data-insmia-mobile-children]");
    group.classList.toggle("is-open", open);
    if (disclosure) disclosure.setAttribute("aria-expanded", open ? "true" : "false");
    if (children) children.hidden = !open;
  }

  function resetMobileNavigation(nav) {
    var defaultPanel = nav.getAttribute("data-insmia-mobile-default-panel") || "new";
    setMobilePanel(nav, defaultPanel, false);

    nav.querySelectorAll("[data-insmia-mobile-group]").forEach(function (group) {
      setMobileDisclosure(group, group.hasAttribute("data-insmia-mobile-default-open"));
    });

    var rail = nav.querySelector("[data-insmia-mobile-tablist]");
    var panelScroller = nav.querySelector("[data-insmia-mobile-panels]");
    if (rail) rail.scrollTop = 0;
    if (panelScroller) panelScroller.scrollTop = 0;
  }

  function initializeMobileNavigation(nav) {
    if (!(nav instanceof HTMLElement) || nav.dataset.insmiaMobileReady === "true") return;
    if (!mobileTabs(nav).length || !nav.querySelector("[data-insmia-mobile-panel]")) return;
    nav.dataset.insmiaMobileReady = "true";

    resetMobileNavigation(nav);
  }

  function initializeNavigation(root) {
    var scope = root instanceof Element || root instanceof Document ? root : document;
    scope.querySelectorAll("[data-insmia-switcher]").forEach(initializeDesktopSwitcher);
    scope.querySelectorAll("[data-insmia-mobile-nav]").forEach(initializeMobileNavigation);
  }

  var initializationQueued = false;

  function queueNavigationInitialization() {
    if (initializationQueued) return;
    initializationQueued = true;

    queueMicrotask(function () {
      initializationQueued = false;
      initializeNavigation(document);
    });
  }

  function containsNavigation(node) {
    if (!(node instanceof Element)) return false;
    return (
      node.matches("[data-insmia-switcher], [data-insmia-mobile-nav]") ||
      Boolean(node.querySelector("[data-insmia-switcher], [data-insmia-mobile-nav]")) ||
      Boolean(node.closest("[data-insmia-switcher], [data-insmia-mobile-nav]"))
    );
  }

  var activeTopOwner = null;
  var activeTopTrigger = null;
  var activeTopSubmenu = null;
  var topCloseTimer = null;
  var topGeometryFrame = null;
  var topResizeObserver = null;

  function topOwnerFromTarget(target) {
    if (!(target instanceof Element)) return null;
    var owner = target.closest(".insmia-topnav__item");
    return owner && owner.closest("header-menu") ? owner : null;
  }

  function topTriggerForOwner(owner) {
    return owner ? owner.querySelector(":scope > .insmia-topnav__link") : null;
  }

  function topSubmenuForOwner(owner) {
    return owner ? owner.querySelector(":scope > .menu-list__submenu") : null;
  }

  function cancelTopClose() {
    if (topCloseTimer === null) return;
    clearTimeout(topCloseTimer);
    topCloseTimer = null;
  }

  function cancelTopGeometryFrame() {
    if (topGeometryFrame === null) return;
    cancelAnimationFrame(topGeometryFrame);
    topGeometryFrame = null;
  }

  function cleanupTopResizeObserver() {
    if (topResizeObserver) topResizeObserver.disconnect();
    topResizeObserver = null;
  }

  function syncTopGeometry() {
    if (!activeTopOwner || !activeTopSubmenu || !activeTopOwner.isConnected) return;

    var headerComponent = activeTopOwner.closest("header-component");
    if (!headerComponent) return;

    var submenuContent = activeTopSubmenu.querySelector(".insmia-submenu");
    var submenuHeight = Math.max(
      activeTopSubmenu.offsetHeight || 0,
      activeTopSubmenu.scrollHeight || 0,
      submenuContent ? submenuContent.scrollHeight || 0 : 0
    );
    var headerHeight = headerComponent.offsetHeight || 0;

    headerComponent.style.setProperty("--submenu-height", submenuHeight + "px");
    headerComponent.style.setProperty(
      "--full-open-header-height",
      submenuHeight ? submenuHeight + headerHeight + "px" : "0px"
    );
  }

  function queueTopGeometrySync() {
    cancelTopGeometryFrame();
    topGeometryFrame = requestAnimationFrame(function () {
      topGeometryFrame = null;
      syncTopGeometry();
    });
  }

  function clearTopDomState() {
    if (activeTopTrigger) activeTopTrigger.setAttribute("aria-expanded", "false");
    if (activeTopSubmenu) activeTopSubmenu.removeAttribute("data-active");
  }

  function closeTopMenu(options) {
    cancelTopClose();
    cancelTopGeometryFrame();
    cleanupTopResizeObserver();

    var focusTrigger = options && options.returnFocus ? activeTopTrigger : null;
    var headerMenu = activeTopOwner ? activeTopOwner.closest("header-menu") : null;
    var headerComponent = activeTopOwner ? activeTopOwner.closest("header-component") : null;

    clearTopDomState();
    if (headerMenu) {
      headerMenu.setAttribute("aria-expanded", "false");
      headerMenu.style.setProperty("--submenu-opacity", "0");
    }
    if (headerComponent) {
      headerComponent.style.setProperty("--submenu-height", "0px");
      headerComponent.style.setProperty("--full-open-header-height", "0px");
    }

    activeTopOwner = null;
    activeTopTrigger = null;
    activeTopSubmenu = null;
    if (focusTrigger instanceof HTMLElement) focusTrigger.focus({ preventScroll: true });
  }

  function openTopMenu(owner) {
    var trigger = topTriggerForOwner(owner);
    var submenu = topSubmenuForOwner(owner);
    var headerMenu = owner ? owner.closest("header-menu") : null;
    if (!trigger || !submenu || !headerMenu) return;

    cancelTopClose();
    if (owner === activeTopOwner) {
      syncTopGeometry();
      return;
    }

    clearTopDomState();
    cleanupTopResizeObserver();
    activeTopOwner = owner;
    activeTopTrigger = trigger;
    activeTopSubmenu = submenu;

    headerMenu.querySelectorAll(".insmia-topnav__link[aria-expanded='true']").forEach(function (link) {
      if (link !== trigger) link.setAttribute("aria-expanded", "false");
    });
    headerMenu.querySelectorAll(".menu-list__submenu[data-active]").forEach(function (surface) {
      if (surface !== submenu) surface.removeAttribute("data-active");
    });

    headerMenu.setAttribute("aria-expanded", "true");
    headerMenu.style.setProperty("--submenu-opacity", "1");
    trigger.setAttribute("aria-expanded", "true");
    submenu.setAttribute("data-active", "");
    submenu.querySelectorAll("img[loading='lazy']").forEach(function (image) {
      image.removeAttribute("loading");
    });

    syncTopGeometry();
    queueTopGeometrySync();
    if (typeof ResizeObserver !== "undefined") {
      topResizeObserver = new ResizeObserver(function () {
        if (activeTopOwner === owner) queueTopGeometrySync();
      });
      topResizeObserver.observe(submenu);
    }
  }

  function scheduleTopClose(owner) {
    if (!owner || owner !== activeTopOwner) return;
    cancelTopClose();
    topCloseTimer = setTimeout(function () {
      topCloseTimer = null;
      if (activeTopOwner !== owner) return;
      var focused = document.activeElement;
      if (focused instanceof Node && owner.contains(focused)) return;
      if (owner.matches(":hover")) return;
      closeTopMenu();
    }, 120);
  }

  function onTopPointerOver(event) {
    if (event.pointerType === "touch") return;
    var owner = topOwnerFromTarget(event.target);
    if (!owner) return;
    cancelTopClose();
    openTopMenu(owner);
  }

  function onTopPointerOut(event) {
    if (event.pointerType === "touch") return;
    var owner = topOwnerFromTarget(event.target);
    if (!owner || owner !== activeTopOwner) return;
    if (event.relatedTarget instanceof Node && owner.contains(event.relatedTarget)) return;
    scheduleTopClose(owner);
  }

  function onTopFocusIn(event) {
    var owner = topOwnerFromTarget(event.target);
    if (!owner) return;
    cancelTopClose();
    openTopMenu(owner);
  }

  function onTopFocusOut(event) {
    var owner = topOwnerFromTarget(event.target);
    if (!owner || owner !== activeTopOwner) return;
    if (event.relatedTarget instanceof Node && owner.contains(event.relatedTarget)) return;
    scheduleTopClose(owner);
  }

  function onSectionLoad(event) {
    initializeNavigation(event.target);
  }

  function onRuntimeProbe(event) {
    event.preventDefault();
  }

  function onDesktopSwitcherPointer(event) {
    var control =
      event.target instanceof Element ? event.target.closest("[data-insmia-switch]") : null;
    var switcher = control ? control.closest("[data-insmia-switcher]") : null;
    if (!control || !switcher) return;
    if (event.relatedTarget instanceof Node && control.contains(event.relatedTarget)) return;

    initializeDesktopSwitcher(switcher);
    activateDesktopSwitcher(switcher, control.getAttribute("data-insmia-switch"), false);
  }

  function onDesktopSwitcherFocus(event) {
    var control =
      event.target instanceof Element ? event.target.closest("[data-insmia-switch]") : null;
    var switcher = control ? control.closest("[data-insmia-switcher]") : null;
    if (!control || !switcher) return;

    initializeDesktopSwitcher(switcher);
    activateDesktopSwitcher(switcher, control.getAttribute("data-insmia-switch"), false);
  }

  function onNavigationKeydown(event) {
    if (event.defaultPrevented) return;

    var keyboardTopOwner = topOwnerFromTarget(event.target);
    var keyboardTopTrigger = topTriggerForOwner(keyboardTopOwner);
    if (
      keyboardTopOwner &&
      keyboardTopTrigger &&
      (event.target === keyboardTopTrigger || keyboardTopTrigger.contains(event.target)) &&
      (event.key === "ArrowDown" || event.key === " " || event.key === "Spacebar")
    ) {
      event.preventDefault();
      openTopMenu(keyboardTopOwner);
      return;
    }

    if (event.key === "Escape" && activeTopOwner) {
      event.preventDefault();
      closeTopMenu({ returnFocus: true });
      return;
    }

    var control =
      event.target instanceof Element ? event.target.closest("[data-insmia-switch]") : null;
    var switcher = control ? control.closest("[data-insmia-switcher]") : null;

    if (control && switcher) {
      var controls = directMatches(switcher, "[data-insmia-switch]");
      var controlIndex = controls.indexOf(control);
      var nextControlIndex = -1;

      if (event.key === "ArrowDown" || event.key === "ArrowRight") {
        nextControlIndex = (controlIndex + 1) % controls.length;
      }
      if (event.key === "ArrowUp" || event.key === "ArrowLeft") {
        nextControlIndex = (controlIndex - 1 + controls.length) % controls.length;
      }
      if (event.key === "Home") nextControlIndex = 0;
      if (event.key === "End") nextControlIndex = controls.length - 1;
      if (nextControlIndex < 0) return;

      event.preventDefault();
      var nextControl = controls[nextControlIndex];
      activateDesktopSwitcher(
        switcher,
        nextControl.getAttribute("data-insmia-switch"),
        nextControl
      );
      return;
    }

    var tab = event.target instanceof Element ? event.target.closest("[data-insmia-mobile-tab]") : null;
    var nav = tab ? tab.closest("[data-insmia-mobile-nav]") : null;
    if (!tab || !nav) return;

    var tabs = mobileTabs(nav);
    var tabIndex = tabs.indexOf(tab);
    var nextTabIndex = -1;

    if (event.key === "ArrowDown") nextTabIndex = (tabIndex + 1) % tabs.length;
    if (event.key === "ArrowUp") nextTabIndex = (tabIndex - 1 + tabs.length) % tabs.length;
    if (event.key === "Home") nextTabIndex = 0;
    if (event.key === "End") nextTabIndex = tabs.length - 1;
    if (nextTabIndex < 0) return;

    event.preventDefault();
    var nextTab = tabs[nextTabIndex];
    setMobilePanel(nav, nextTab.getAttribute("data-insmia-mobile-tab"), nextTab);
  }

  function onNavigationClick(event) {
    if (event.defaultPrevented) return;

    var topOwner = topOwnerFromTarget(event.target);
    var topTrigger = topTriggerForOwner(topOwner);
    if (
      topOwner &&
      topTrigger &&
      topSubmenuForOwner(topOwner) &&
      window.matchMedia("(hover: none), (pointer: coarse)").matches &&
      topOwner !== activeTopOwner
    ) {
      event.preventDefault();
      openTopMenu(topOwner);
      return;
    }

    var closeButton =
      event.target instanceof Element ? event.target.closest("[data-insmia-mobile-close]") : null;
    if (closeButton) {
      var drawer = closeButton.closest("header-drawer");
      var details = drawer ? drawer.querySelector(":scope > details") : null;
      if (details) {
        event.preventDefault();
        details.classList.remove("menu-open");
        details.open = false;
        var summary = details.querySelector(":scope > summary");
        if (summary) {
          summary.setAttribute("aria-expanded", "false");
          summary.focus();
        }
        details.dispatchEvent(new CustomEvent("insmia:drawer-closed", { bubbles: true }));
      }
      return;
    }

    var disclosure =
      event.target instanceof Element ? event.target.closest("[data-insmia-mobile-disclosure]") : null;
    var nav = disclosure ? disclosure.closest("[data-insmia-mobile-nav]") : null;

    if (disclosure && nav) {
      event.preventDefault();
      event.stopPropagation();
      var group = disclosure.closest("[data-insmia-mobile-group]");
      setMobileDisclosure(group, disclosure.getAttribute("aria-expanded") !== "true");
      return;
    }

    var tab = event.target instanceof Element ? event.target.closest("[data-insmia-mobile-tab]") : null;
    nav = tab ? tab.closest("[data-insmia-mobile-nav]") : null;
    if (!tab || !nav) return;

    event.preventDefault();
    setMobilePanel(nav, tab.getAttribute("data-insmia-mobile-tab"), false);
  }

  function onDrawerOpen(event) {
    var scope = event.target instanceof Element ? event.target : document;
    scope.querySelectorAll("[data-insmia-mobile-nav]").forEach(function (nav) {
      initializeMobileNavigation(nav);
      resetMobileNavigation(nav);
    });
  }

  function onDrawerToggle(event) {
    var details = event.target;
    if (!(details instanceof HTMLDetailsElement)) return;

    var summary = details.querySelector(":scope > summary");
    details.classList.toggle("menu-open", details.open);
    if (summary) summary.setAttribute("aria-expanded", details.open ? "true" : "false");
    if (details.open) {
      details.querySelectorAll("[data-insmia-mobile-nav]").forEach(function (nav) {
        initializeMobileNavigation(nav);
        resetMobileNavigation(nav);
      });
    }
  }

  var navigationObserver = null;
  var observedDocumentElement = null;

  function ensureNavigationObserver() {
    var currentDocumentElement = document.documentElement;
    if (!currentDocumentElement || observedDocumentElement === currentDocumentElement) return;

    if (navigationObserver) navigationObserver.disconnect();
    observedDocumentElement = currentDocumentElement;
    navigationObserver = new MutationObserver(function (records) {
      var navigationAdded = records.some(function (record) {
        return Array.prototype.some.call(record.addedNodes, containsNavigation);
      });

      if (navigationAdded) queueNavigationInitialization();
    });
    navigationObserver.observe(currentDocumentElement, {
      childList: true,
      subtree: true,
    });
  }

  function initializeRuntime() {
    if (activeTopOwner && !activeTopOwner.isConnected) closeTopMenu();
    ensureNavigationObserver();
    initializeNavigation(document);
    document.documentElement.setAttribute("data-insmia-navigation-runtime", String(runtimeVersion));
    document.documentElement.removeAttribute("data-insmia-navigation-error");
  }

  function onRuntimeInitialize() {
    try {
      initializeRuntime();
    } catch (error) {
      document.documentElement.setAttribute(
        "data-insmia-navigation-error",
        error instanceof Error ? error.name + ": " + error.message : String(error)
      );
    }
  }

  window.addEventListener(runtimeProbeEvent, onRuntimeProbe);
  window.addEventListener(runtimeInitializeEvent, onRuntimeInitialize);
  window.addEventListener("load", onRuntimeInitialize);
  window.addEventListener("pageshow", onRuntimeInitialize);
  window.addEventListener("popstate", onRuntimeInitialize);
  window.addEventListener("shopify:section:load", onSectionLoad);
  window.addEventListener("insmia:drawer-open", onDrawerOpen);
  window.addEventListener("toggle", onDrawerToggle, true);
  window.addEventListener("pointerover", onTopPointerOver, { capture: true, passive: true });
  window.addEventListener("pointerout", onTopPointerOut, { capture: true, passive: true });
  window.addEventListener("focusin", onTopFocusIn, true);
  window.addEventListener("focusout", onTopFocusOut, true);
  window.addEventListener("pointerover", onDesktopSwitcherPointer, {
    capture: true,
    passive: true,
  });
  window.addEventListener("focusin", onDesktopSwitcherFocus, true);
  window.addEventListener("keydown", onNavigationKeydown, true);
  window.addEventListener("click", onNavigationClick);

  onRuntimeInitialize();
})();
